import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { JobStore } from "@app/services/store/job-store";
import { environment as env } from "@env/environment";
import { Job_DetailProjection } from "@app/models/rest/job";
import { VisitStatus } from "@app/models/enums/visit-status.enum";
import { Job_EmbeddedVisitProjection } from "@app/models/rest/visit";
import {
  MatCard,
  MatCardHeader,
  MatCardContent,
  MatCardFooter
} from "@angular/material/card";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { VisitBookingComponent } from "../visit-booking/visit-booking.component";

@Component({
  selector: "app-job-booking-component",
  templateUrl: "./job-booking-component.component.html",
  styleUrls: ["./job-booking-component.component.scss"],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardFooter,
    MatToolbar,
    MatToolbarRow,
    MatButton,
    VisitBookingComponent
  ]
})
export class JobBookingComponentComponent {
  protected activatedRoute = inject(ActivatedRoute);
  protected jobStore = inject(JobStore);

  public job: Job_DetailProjection;
  VisitStatus = VisitStatus;
  newVisitList: Job_EmbeddedVisitProjection[] = [];
  rebookingMode: boolean = false;
  existingAppointmentList: Job_EmbeddedVisitProjection[];
  public env = env;
  selectedVisitId: number;
  public errorMessage = null;
  protected externalJobRef = "";

  constructor() {
    const activatedRoute = this.activatedRoute;

    activatedRoute.params.subscribe((params) => {
      console.log("");
      this.externalJobRef = params["externalJobRef"];
      this.loadJobRecord();
    });
  }

  loadJobRecord() {
    if (!this.externalJobRef) {
      return;
    }
    this.jobStore
      .loadSingleWithSearch(
        "findDistinctByExternalJobReferenceEquals",
        {
          params: {
            externalJobRef: this.externalJobRef,
            projection: "detail"
          }
        },
        true
      )
      .then((value) => {
        console.log("loaded job");
        console.log(value);
        this.job = value;
        this.newVisitList = this.job.visitList.filter(
          (value1) =>
            value1.visitStatus === VisitStatus.NEW ||
            value1.visitStatus === VisitStatus.AUTO
        );

        if (this.newVisitList.length > 0) {
          this.selectedVisitId = this.newVisitList[0].id;
        }

        this.existingAppointmentList = this.job.visitList.filter(
          (value1) => value1.visitStatus === VisitStatus.BOOKED
        );
      })
      .catch((reason) => {
        this.errorMessage = reason;
      });
  }

  launchScheduler() {
    window.open("/", "_blank");
  }

  handleBooked(event: any) {
    console.log("handleBooked called with event:", event);

    // Only proceed if the booking was successful
    if (!event || !event.booked) {
      console.log("Booking was not successful, not removing visit from list");
      return;
    }

    const visitId = this.selectedVisitId;
    console.log("Booking was successful for visitId:", visitId);

    if (this.rebookingMode) {
      let index = this.existingAppointmentList.findIndex(
        (value) => value.id === visitId
      );
      console.log("visit index ", index);
      if (index !== -1) {
        this.existingAppointmentList.splice(index, 1);
      }
      console.log("handling visit booked");
      console.log(this.existingAppointmentList);

      // Update selectedVisitId to the next available visit
      if (this.existingAppointmentList.length > 0) {
        this.selectedVisitId = this.existingAppointmentList[0].id;
      } else {
        console.log("No more visits to rebook, attempting window close");
        window.close();
      }
    } else {
      let index = this.newVisitList.findIndex((value) => value.id === visitId);
      console.log("visit index ", index);
      if (index !== -1) {
        this.newVisitList.splice(index, 1);
      }
      console.log("handling visit booked");
      console.log(this.newVisitList);

      // Update selectedVisitId to the next available visit
      if (this.newVisitList.length > 0) {
        this.selectedVisitId = this.newVisitList[0].id;
      } else {
        console.log("No more visits to book, attempting window close");
        window.close();
      }
    }
  }
}
